import getPaymentMethods from 'lib/getPaymentMethods'
import config from '../constants/config'

export default function shouldShowGiftCards(currencyCode: string) {
  return config.ENABLE_GIFT_CARD && getPaymentMethods(currencyCode).includes('giftcard')
}
